try {

    // Vendor libs
    window.$ = window.jQuery = require('jquery');
    window.jQueryBridget = require('jquery-bridget');
    window.Masonry = require('masonry-layout');
    window.flickity = require('flickity');

    // make Masonry a jQuery plugin
    jQueryBridget( 'masonry', Masonry, $ );

    // TWBS
    window.Popper = require('popper.js/dist/umd/popper.js').default;
    require('bootstrap');

    jQuery.fn.exists = function(){return this.length>0;}

    $.fn.serializeObject = jQuery.fn.serializeObject = function() {
      var o = {};
      var a = this.serializeArray();
      $.each(a, function() {
       if (o[this.name] !== undefined) {
         if (!o[this.name].push) {
           o[this.name] = [o[this.name]];
         }
         o[this.name].push(this.value || '');
       } else {
         o[this.name] = this.value || '';
       }
      });
      return o;
    };

} catch (e) {
  console.log(e);
}
